<template>
  <div class="">
    <van-nav-bar
      title="活动专区"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    activity</div>
</template>
<script>
import Vue from 'vue';
import { NavBar } from 'vant';

Vue.use(NavBar);
export default {
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>